module.exports = __webpack_public_path__ + "static/media/menu.910dfa13.png";